module.exports = __webpack_public_path__ + "img/lo-fi.9f9a9e36.png";